import * as React from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import notify from '../../../shared/feedback/notifications';
import { Translate } from '../../../shared/LanguageService';
import ICalendarItem from '../../calendar/Types';
import ScandphotosPhotographerBooking from './ScandphotosPhotographerBooking';
import * as Actions from './actions/ScandphotosPhotographerBookingActions';
import Loader from 'react-loader';

interface IPhotographerBookingPageActions {
    getPhotographers: (orderId: number) => any;
    updatePhotographer: (data: any) => any;
}

interface IPhotographerBookingPageProps {
    orderInfo: any;
    actions: IPhotographerBookingPageActions;
    location: any;
    history: any;
}

class ScandphotosPhotographerBookingPage extends React.Component<
    IPhotographerBookingPageProps,
    any
> {
    constructor(props: IPhotographerBookingPageProps, context: any) {
        super(props, context);

        this.state = {
            loading: true
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: IPhotographerBookingPageProps, nextState: any) {
        let orderInfo = nextProps.orderInfo;
        if (!orderInfo) {
            return;
        }

        this.setState({
            loading: false,
            orderInfo: orderInfo,
            calendarItem: {}
        });
    }

    componentDidMount(): void {
        const params = parse(this.props.location.search);

        if (params.orderId !== undefined) {
            let orderId = Number(params.orderId);
            this.props.actions.getPhotographers(orderId);
        }
    }

    redirectToOrdersPage() {
        const params = parse(this.props.location.search);
        this.props.history.push(params.redirectTo);
    }

    onPhotographerSelected(calendarItem: ICalendarItem) {
        if (!calendarItem) {
            this.redirectToOrdersPage();
        } else {
            const params = parse(this.props.location.search);
            if (params.orderId !== undefined) {
                let orderId = Number(params.orderId);

                calendarItem.orderId = orderId;
                this.props.actions
                    .updatePhotographer({ calendarItem: calendarItem })
                    .then(() => {
                        notify.success(Translate('scandphotos/photographerbooking/toastr/success'));
                        this.redirectToOrdersPage();
                    })
                    .catch(() => {
                        notify.failure(Translate('scandphotos/photographerbooking/toastr/error'));
                    });
            }
        }
    }

    render() {
        return (
            <div>
                {this.state.loading && (
                    <div style={{ height: '50vh' }}>
                        <Loader loaded={!this.state.loading}></Loader>
                    </div>
                )}
                {!this.state.loading && (
                    <div>
                        <ScandphotosPhotographerBooking
                            onSelected={(calendarItem) => {
                                this.onPhotographerSelected(calendarItem);
                            }}
                            orderInfo={{
                                orderId: this.state.orderInfo.id,
                                address: this.state.orderInfo.address,
                                postalCode: this.state.orderInfo.postalCode,
                                city: this.state.orderInfo.city,
                                product: {
                                    name: '',
                                    executionTime: this.state.orderInfo.executionTime
                                },
                                additionalProducts: [],
                                brokerFirmRegionId: this.state.orderInfo.brokerFirmRegionId,
                                brokerFirmId: this.state.orderInfo.brokerFirmId
                            }}
                            buttonLabel={Translate('scandphotos/photographerbooking/button/book')}
                        />
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        orderInfo: state.ScandphotosPhotographerBooking.orderInfo
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPhotographers: (orderId: number) => dispatch(Actions.getOrderInfo(orderId)),
            updatePhotographer: (data: any) => dispatch(Actions.updatePhotographer(data))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScandphotosPhotographerBookingPage);
